import React from "react";
import {IPredictionsHistory, IUserProfilePrediction} from "modules/actions/leaderboards";
import {useSelector} from "react-redux";
import {getPlayerByIdSelector} from "modules/selectors";
import styled from "@emotion/styled";
import {StreakBadge} from "components/StreakBadge";
import {buildStreakStatus} from "modules/utils/streak";
import {getMatchByIdSelector} from "modules/selectors/units";
import {Exist} from "components/Exist";
import {useTranslation} from "react-i18next";
import {buildPlayerFullName} from "modules/utils/players";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
`;

const PlayerNames = styled.div`
	white-space: nowrap;
`;

interface IProps {
	predictions?: IPredictionsHistory;
	isHideStreak?: boolean;
}

const MyPlayers: React.FC<IProps> = ({predictions, isHideStreak}) => {
	const playersSelector = useSelector(getPlayerByIdSelector);
	const matchSelector = useSelector(getMatchByIdSelector);
	const i18n = useTranslation();

	const getPredictionPlayerOrHidden = (pick: IUserProfilePrediction) => {
		if (pick.playerId === null && pick.number === 2) {
			return (
				<p key={pick.playerId}>
					{i18n.t("leaderboards.table.empty_dd", "DD: batter hidden")}
				</p>
			);
		}
		const player = playersSelector(pick.playerId);

		const playerName = buildPlayerFullName(player);
		return <p key={pick.playerId}>{playerName}</p>;
	};

	if (!predictions?.roundPredictions.length) {
		return null;
	}

	return (
		<Wrapper>
			<PlayerNames>
				{predictions?.roundPredictions.map(getPredictionPlayerOrHidden)}
			</PlayerNames>

			<Exist when={!isHideStreak}>
				<StreakBadge
					pick={{
						result: buildStreakStatus(predictions?.roundPredictions, matchSelector),
						streak: predictions.streak || 0,
					}}
				/>
			</Exist>
		</Wrapper>
	);
};

export default MyPlayers;
